module.exports = __webpack_public_path__ + "media/assets/images/pq1-833995202c22f10ad4082e51047db1fd.svg";